<template>
<div>

  <div class="container" id="confirm-request">
    <div  class="ui row">
      <div v-if="confirmed" class="col-sm-24">
        <p>
          <div class="ui positive message">
            <div class="header">
              <h3>{{$t('Deine Nachricht wurde erfolgreich gesendet')}}</h3>
            </div>
            <p></p>
          </div>
        </p>
      </div>
      <div v-if="error" class="col-sm-24">
        <p>
          <div  v-if="!code" class="ui negative message">
            <div class="header">
              <h3>{{$t('Es ist ein Fehler aufgetreten')}}</h3>
            </div>
          </div>
          <div v-if="code == 201" class="ui info message">
            <div class="header">
              <h3>{{$t('Deine Nachricht wurde bereits erfolgreich gesendet')}}</h3>
            </div>
          </div>
        </p>
      </div>

    </div>
  </div>

</div>
</template>

<script>

import Config from '../Config';

import {
  mapState,
  mapActions
} from 'vuex'
import {
  formatDateOnly
} from '../utils/DateFormatter.js'
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'SearchSubscriptionHandler',
  props: {},
  data: function() {
    return {
      ready: false,
      state: undefined,
      type: undefined,
      confirmed: false,
      unsubscribed: false,
      error: false,
      code: 0,
      requestKey: null
    }
  },
  components: {

  },
  computed: {

  },
  created() {

    console.log(this.$route.params);

    if(this.$route.params.key){
      this.requestKey = this.$route.params.key;
    } else {
      this.error = true;
    }

    if(this.requestKey){
      this.confirmRequest();

    } else {
      this.error = true;
    }

  },mounted: function () {
    this.$nextTick(() => {
      this.ready = true;
    });
  },
  methods: {

    confirmRequest: function(){
      this.$store.dispatch('summery/confirmRequest', this.requestKey).then((x) => {
        this.confirmed = !x.error;
        this.error = x.error;
        this.code = x.code;
      }, (e) => {
        this.confirmed = false;
        this.error = true;
      })

      VueScrollTo.scrollTo('#confirm-request',{offset:-114});

    }
  },
  beforeRouteEnter(to, from, next) {
    window.previousUrl = from.path
      next((vm) => {
          vm.from = from;
      });
  }


}
</script>

<style scoped>

.ui.positive.message{
    background-color: #fcfff5;
    color: #2c662d;
}

.ui.info.message {
    background-color: #f8ffff;
    color: #276f86;
}
.ui.negative.message {
    background-color: #fff6f6;
    color: #9f3a38;
}

.ui.message {
    position: relative;
    min-height: 1em;
    margin: 1em 0;
    padding: 1em 1.5em;
    line-height: 1.4285em;
    -webkit-transition: opacity .1s ease,color .1s ease,background .1s ease,-webkit-box-shadow .1s ease;
    transition: opacity .1s ease,color .1s ease,background .1s ease,-webkit-box-shadow .1s ease;
    transition: opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease;
    transition: opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease,-webkit-box-shadow .1s ease;
    -webkit-box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 0 0 0 transparent;
    box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 0 0 0 transparent;
}

</style>
